import { FLIGHT_LIMITS } from '../constants'

// Define flight type for managing multiple flights
export type FlightType = {
  id: string
  origin: string
  destination: string
  departureDate: Date | undefined
}

// Flight management utility functions
export const createNewFlight = (lastFlight: FlightType): FlightType => ({
  id: Date.now().toString(),
  origin: lastFlight.destination, // Set origin as previous destination
  destination: '',
  departureDate: undefined
})

export const canAddMoreFlights = (currentFlights: FlightType[]): boolean => {
  return currentFlights.length < FLIGHT_LIMITS.MAX_FLIGHTS
}

export const canRemoveFlight = (currentFlights: FlightType[]): boolean => {
  return currentFlights.length > FLIGHT_LIMITS.MIN_FLIGHTS
}

export const addFlightToList = (flights: FlightType[]): FlightType[] => {
  if (!canAddMoreFlights(flights)) {
    return flights
  }

  const lastFlight = flights[flights.length - 1]
  const newFlight = createNewFlight(lastFlight)
  return [...flights, newFlight]
}

export const removeFlightFromList = (
  flights: FlightType[],
  flightId: string
): FlightType[] => {
  if (!canRemoveFlight(flights)) {
    return flights
  }

  return flights.filter(flight => flight.id !== flightId)
}

export const updateFlightInList = (
  flights: FlightType[],
  flightId: string,
  field: keyof FlightType,
  value: string | Date | undefined
): FlightType[] => {
  return flights.map(flight =>
    flight.id === flightId ? { ...flight, [field]: value } : flight
  )
}
